export default {
    data() {
        return {
            alert: {
                isshow: false,
            },
            curTabId: parseInt(this.$route.params.tabid),
            orderStatus: [{
                    id: 1,
                    name: "等待确认",
                    selected: true
                },
                {
                    id: 2,
                    name: "面试订单",
                    selected: false
                },
                {
                    id: 3,
                    name: "成交订单",
                    selected: false
                },
            ],
            orderList: [],
            page: 1,
            pageSize: 10,
            totalCount: 0,
            isLoaded: false, //是否首页加载完

            pulluploadingtext: "正在努力加载更多…", //上拉加载中显示文案
            pulluptext: '', //上拉加载条文案
            allowpullup: true, //是否允许上拉加载
            pullend: false, //是否加载完
            isscroll: true //是否可以滚动加载
        }
    },
    mounted() {
        this.init();
    },
    watch: {
        '$route': function(to, from) {
            if (to && to.name === 'releaseClientJobList') {
                this.init();
            }
        }
    },
    methods: {
        init() {
            this.curTabId = parseInt(this.$route.params.tabid);
            this.isLoaded = false;
            this.page = 1;
            this.switchStatusTab(this.curTabId);
            this.getList();
        },
        //检测筛选条件
        resetParameter() {
            let self = this;
            let _param = {
                OrderType: self.curTabId,
                Page: self.page,
                Length: self.pageSize,
            };
            return _param;
        },
        //获取订单列表
        getList() {
            //根据curTabId更新orderList
            var self = this;
            // self.isLoaded = false;
            this.page = 1;
            let _param = this.resetParameter();
            this.$post("/customerservicemanager/getpublishlistjob", _param, function(ret) {
                if (ret.Success) {
                    self.isLoaded = true;
                    if (ret.Result && ret.Result.TotalCount && ret.Result.TotalCount > 0) {
                        self.orderList = ret.Result.ListCustomerJob;
                        self.totalCount = ret.Result.TotalCount;
                    } else {
                        self.orderList = [];
                        self.totalCount = 0;
                    }
                } else {
                    self.isLoaded = true;
                    self.$toast(ret.Message);
                }
            });
        },
        //内容拉到底部，上拉加载更多
        pullUpdate() {
            let self = this;
            let fullTotal = this.pageSize * this.page;
            if (this.totalCount && fullTotal <= this.totalCount) {
                this.setTranslate();
                if (this.page == 0) {
                    this.page = 1;
                } else {
                    this.page++;
                }
                let _param = this.resetParameter();
                this.$post("/customerservicemanager/getpublishlistjob", _param, function(ret) {
                    if (ret.Result && ret.Result.ListCustomerJob && ret.Result.ListCustomerJob.length > 0) {
                        ret.Result.ListCustomerJob.map(item => {
                            self.orderList.push(item);
                        });
                    } else {
                        self.clearTranslate();
                    }
                })
            } else {
                this.clearTranslate();
            }
        },
        bindScrollEvents() {
            this.$el.querySelector(".user-my-order").addEventListener('scroll', this.scrollEvents);
        },
        scrollEvents() {
            let self = this;
            if (this.allowpullup) {
                let target = this.$el.querySelector(".user-my-order");
                // let scrollLimit = target.scrollHeight - target.offsetHeight;
                let pullUp = self.$el.querySelector(".pull-up");
                let pullUpTop = pullUp.offsetTop;

                if (pullUpTop <= target.offsetHeight + target.scrollTop + 150 && self.isscroll) {
                    self.pullUpdate();
                    self.isscroll = false;
                    this.resetScroll = setTimeout(function() {
                        self.isscroll = true;
                        //clearTimeout(this.resetScroll);
                    }, 1500);
                }
            }
        },
        setTranslate(text) {
            if (!this.pullend) {
                this.pullend = false;
            }
            this.pulluptext = text ? text : this.pulluploadingtext;
            this.allowpullup = true;
        },
        clearTranslate() {
            this.pulluptext = '没有更多了哦~';
            this.allowpullup = true;
            this.pullend = true;
            this.isscroll = false;
        },


        //切换订单列表
        switchStatusTab(itemId) {
            let self = this;
            this.orderStatus.map(item => {
                if (item.id == parseInt(itemId)) {
                    self.curTabId = parseInt(itemId);
                    item.selected = true;
                    self.page = 1;
                    //更新数据
                    this.getList();
                } else {
                    item.selected = false;
                }
            });
        },
        //查看详情
        viewDetail(orderNum) {
            this.$router.push({
                path: "/release/clientJobDetail/" + orderNum,
                query: {
                    tabid: this.curTabId,
                    fromPage: 1,
                }
            });
        },
        //自定义返回
        customBack() {
            this.$router.push({
                path: "/center",
                query: {

                }
            });
        },
    },
}


// WEBPACK FOOTER //
// ./src/ally/page/release/clientJobList.js